import {Middleware, isRejected} from '@reduxjs/toolkit';
import {Bounce, toast} from 'react-toastify';

export const GENERIC_ERROR_MESSAGE = 'Oeps! Er is iets mis gegaan.';

export function showErrorToast(message = GENERIC_ERROR_MESSAGE) {
    toast.error(message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        transition: Bounce,
    });
}

function isSilent(action: unknown): boolean {
    if (typeof action !== 'object' || action === null || !('meta' in action)) {
        return false;
    }
    const meta = action.meta;
    if (typeof meta !== 'object' || meta === null || !('arg' in meta)) {
        return false;
    }
    const arg = meta.arg;
    return typeof arg === 'object' && arg !== null && 'silent' in arg && arg.silent === true;
}

export const toastErrorMiddleware: Middleware = () => (next) => (action) => {
    if (
        isRejected(action) &&
        action.error !== undefined &&
        action.error !== null &&
        !action.error.message?.includes('401') &&
        !isSilent(action)
    ) {
        console.error(action);

        const message =
            'error' in action &&
            typeof action.error === 'object' &&
            'data' in action.error &&
            typeof action.error.data === 'object' &&
            action.error.data != null &&
            'message' in action.error.data &&
            typeof action.error.data.message === 'string'
                ? action.error.data.message
                : GENERIC_ERROR_MESSAGE;

        showErrorToast(message);
    }

    return next(action);
};
